<template>
    <views class="aritcle-item" @click="onClick">
        <views class="aritcle-item-img">
            <images :src="shopImg"></images>
        </views>
        <views class="aritcle-item-content">
            <views
                :class="{'only-title': onlyTitle}"
                class="aritcle-item-content-title">
                {{ item.name }}
            </views>
            <views
                v-if="!onlyTitle"
                class="aritcle-item-content-des">
                {{ item.introduce }}
            </views>
            <views class="aritcle-item-content-tag">
                <views class="aritcle-item-content-time">
                    <images :src="phoneIcon"></images>
                    <a :href="tel(item.contact)" @click.stop>{{ item.contact }}</a>
                </views>
                <views class="aritcle-item-content-addr" @click="handleAddr">
                    <images :src="addrIcon"></images>
                </views>
            </views>
        </views>
    </views>
</template>

<script>
export default {
    props: {
        onlyTitle: {
            type: Boolean,
            default: false
        },
        item: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            phoneIcon: require('@/assets/images/phone_icon.png'),
            addrIcon: require('@/assets/images/addr.png'),
            shopImg: require('@/assets/images/shop.png')
        }
    },
    methods: {
        onClick() {
            this.$emit('click', this.item)
        },
        tel(str) {
            return `tel:${str}`
        },
        handleAddr() {
            event.stopPropagation()
            this.$emit('addr', this.item)
        }
    }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
